import { connect } from "react-redux";

import {
  addClientLocation,
  createClient,
  getClientLocation,
  getClientShortList,
  updateClientLocation,
} from "../../ClientsNew/clientsActions";
import {
  createOrgLocation,
  getOrganizationLocations,
} from "../../Organization/OrganizationActions";
import { getOrganizationMembersShortList } from "../../Projects/projectsActions";
import {
  getWorkOrderShortList,
  updateJobRequest,
} from "../../WorkOrderNew/workOrderActions";
import {
  createJobDocument,
  createSubtask,
  deleteJobDocument,
  deleteSubtask,
  getJobDetails,
  getJobDocuments,
  getSubtasks,
  resetSubtaskStatus,
  updateSubtask,
} from "../jobsActions";
import { addTaskLocation, getTaskLocation, getTaskType } from "../tasksActions";
// Component
import EditJobPopup from "./EditJobPopup";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersShortList: state.project.orgMembersShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  isLoading: state.task.isLoading,
  addTaskLocationLoading: state.task.addTaskLocationLoading,
  locationsList: state.task.locationsList,
  createdTaskLocationInfo: state.task.createdTaskLocationInfo,
  taskTypeIsLoading: state.task.taskTypeIsLoading,
  taskTypeList: state.task.taskTypeList,
  //workordershort
  workOrderShortList: state.workorder.workOrderShortList,
  //Customer Location
  clientLocationList: state.client.clientLocationList,
  getclientLocalMapLoading: state.client.getclientLocalMapLoading,
  addOrUpdateclientLocalMapLoading:
    state.client.addOrUpdateclientLocalMapLoading,
  createdClientLocationInfo: state.client.createdClientLocationInfo,
  //Client Short List
  clientShortList: state.client.clientShortList,
  //Client
  isClientLoading: state.client.isLoading,
  createdClientId: state.client.createdClientId,
  createdClientInfo: state.client.createdClientInfo,
  //Organization Location
  organizationLocationList: state.organization.organizationLocationList,
  getOrganizationLocationLoading:
    state.organization.getOrganizationLocationLoading,
  addOrgLocationLoading: state.organization.addOrgLocationLoading,
  createdOrgLocationInfo: state.organization.createdOrgLocationInfo,
  //job
  jobDetails: state.jobs.jobDetails,
  getJobIsLoading: state.jobs.getJobIsLoading,
  createOrUpdateJobIsLoading: state.workorder.createOrUpdateJobIsLoading,
  jobUpdate: state.workorder.jobUpdate,
  updatedJob: state.workorder.updatedJob,
  // subtasks
  subtasks: state.jobs.subtasks,
  isLoadingSubtasks: state.jobs.isLoadingSubtasks,
  subtaskCreated: state.jobs.subtaskCreated,
  subtaskUpdated: state.jobs.subtaskUpdated,
  subtaskDeleted: state.jobs.subtaskDeleted,
  // job documents
  jobDocuments: state.jobs.jobDocuments,
  documentLoading: state.jobs.isLoadingJobDocuments,
  documentDone: state.jobs.jobDocumentDone,
  documentError: state.jobs.error,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersShortList: params =>
    dispatch(getOrganizationMembersShortList(params)),
  getTaskLocation: params => dispatch(getTaskLocation(params)),
  addTaskLocation: params => dispatch(addTaskLocation(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  getWorkOrderShortList: params => dispatch(getWorkOrderShortList(params)),
  getClientLocation: details => dispatch(getClientLocation({ ...details })),
  getClientShortList: details => dispatch(getClientShortList({ ...details })),
  createClient: details => dispatch(createClient(details)),
  getOrganizationLocations: details =>
    dispatch(getOrganizationLocations({ ...details })),
  createOrgLocation: details => dispatch(createOrgLocation({ ...details })),
  addClientLocation: details => dispatch(addClientLocation({ ...details })),
  updateClientLocation: details =>
    dispatch(updateClientLocation({ ...details })),
  updateJobRequest: details => dispatch(updateJobRequest({ ...details })),
  getJobDetails: details => dispatch(getJobDetails({ ...details })),
  // subtasks
  getSubtasks: params => dispatch(getSubtasks(params)),
  createSubtask: params => dispatch(createSubtask(params)),
  updateSubtask: params => dispatch(updateSubtask(params)),
  deleteSubtask: params => dispatch(deleteSubtask(params)),
  resetSubtaskStatus: () => dispatch(resetSubtaskStatus()),

  // Job Documents
  getJobDocuments: details => dispatch(getJobDocuments(details)),
  createJobDocument: details => dispatch(createJobDocument(details)),
  deleteJobDocument: details => dispatch(deleteJobDocument(details)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(EditJobPopup);
